import "./assets/scss/custom.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

import { Provider as ReduxProvider } from "react-redux";
import { store } from "./store/index";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
    <ToastContainer />
  </>,
);
